var TIMESTAMP = null;

// Component to change videosphere on click and set markers/hotspots.
AFRAME.registerComponent('enter-site', {
    schema: {
        on: {type: 'string', default: 'click'},
        target: {type: 'selector', default: 'a-videosphere'},
        src: {type: 'string'},
        dur: {type: 'number', default: 300}
    },

    init: function () {
        var data = this.data;
        var el = this.el;
        var targetEl = this.data.target;

        this.setupFadeAnimation();

        el.addEventListener(data.on, function (evt) {

            if(TIMESTAMP == null || TIMESTAMP + 1000 < evt.timeStamp) {

                var videoID = data.src.replace("#", "");
                var video = document.getElementById(videoID);
                var offsetY = video.getAttribute("offset-y");
                video.currentTime = 0;
                video.pause();


                console.log("videoID"+videoID);

                // Fade out video.
                targetEl.emit('fade-video-out');

                // Wait for fade to complete.
                setTimeout(function () {
                    // Set video.
                    navigate(data.src);
                    //queryString.push('location', data.src.replace("#", ""));
                    targetEl.setAttribute('material', 'src', data.src);
                    targetEl.setAttribute('rotation', 'y', offsetY);
                    targetEl.emit('fade-video-in');

                    var videoEl = document.querySelector(data.src);
                    videoEl.currentTime = 0;
                    videoEl.play();

                }, data.dur);

                TIMESTAMP = evt.timeStamp;
            }

        });
    },
    //
    // Setup fade-in + fade-out.
    //
    setupFadeAnimation: function () {
        var data = this.data;
        var targetEl = this.data.target;
        // Only set up once.
        if (targetEl.dataset.setVideoFadeSetup) { return; }
        targetEl.dataset.setVideoFadeSetup = true;

        // Create animations.
        targetEl.setAttribute('animation__fadeout', {
            property: 'material.color',
            startEvents: 'fade-video-out',
            dir: 'normal',
            dur: data.dur,
            from: '#fff',
            to: '#000'
        });
        targetEl.setAttribute('animation__fadein', {
            property: 'material.color',
            startEvents: 'fade-video-in',
            dir: 'normal',
            dur: data.dur,
            from: '#000',
            to: '#fff'
        });
    }
});


// navigate to new location and fade out old location out / assume site-a if no old location

const navigate = function(loc) {
//const navigate = (loc) => {

    var skyObj = document.querySelector('a-videosphere').components.material;
    var oldNav = null;
    
    if ( typeof skyObj === 'undefined' ) {
        oldNav = "nav_site-a"
    } else {
        oldNav = "nav_" + skyObj.oldData.src.id;
    }
    
    console.log("oldNav :"+ oldNav);
    const oldNavEl = document.getElementById(oldNav);
    oldNavEl.setAttribute('visible', 'false');
    oldNavEl.setAttribute('scale', '0.0001 0.0001 0.0001');

    var nav = loc.replace("#", "nav_");
    console.log("nav :"+ nav);
    const navEl = document.getElementById(nav);
    navEl.setAttribute('visible', 'true');
    navEl.setAttribute('scale', '1 1 1');    
}



//////////////////
// WEBPACK FOOTER
// ./src/enter-site.js
// module id = 3
// module chunks = 0